import { Global, css } from '@emotion/react'

export const GlobalStyles = () => (
  <Global
    styles={css`
      * {
        box-sizing: border-box;
        font-family:
          'Open Sans',
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          'Roboto',
          'Oxygen',
          'Ubuntu',
          'Cantarell',
          sans-serif;
      }

      body {
        margin: 0;
      }

      .Toastify__toast {
        width: auto !important;
        max-width: none !important;
        min-width: auto !important;
      }
    `}
  />
)
